import { useStore } from 'vuex';

import {RootState} from "@/store";

/**
 * Composable для работы с переводами
 */
export function useTranslation() {
  const store = useStore<RootState>();

  // Основные функции переводов (используют store геттер)
  const tg = (groupName: string, code: string): string => {
    return store.getters['i18n/translate'](code, groupName);
  };

  const tp = (code: string, params?: Record<string, string>): string => {
    let translation = store.getters['i18n/translate'](code);
    
    if (params) {
      // Заменяем параметры в формате [[:variable]] на значения из params
      Object.keys(params).forEach(key => {
        const placeholder = `[[:${key}]]`;
        translation = translation.replace(new RegExp(placeholder, 'g'), params[key] || '');
      });
    }
    
    return translation;
  };

  // Методы для установки переводов
  const setGroupTranslations = (groupName: string, groupItems: { [key: string]: any }) => {
    store.dispatch('i18n/setGroupTranslations', { groupName, groupItems });
  };

  const setPageTranslations = (data: { name: string, breadCrumb: any, items: { [key: string]: any }, entities: { [key: string]: { one: string; many: string } } }) => {
    store.dispatch('i18n/setPage', data);
  };

  const clearTranslations = () => {
    store.dispatch('i18n/clearTranslations');
  };

  // Функции для работы с entities
  const te = (entityKey: string, form: 'one' | 'many'): string => {
    return store.getters['i18n/getEntityTranslation'](entityKey, form);
  };

  // Удобные функции для часто используемых случаев
  const te_one = (entityKey: string): string => {
    return store.getters['i18n/getEntityTranslation'](entityKey, 'one');
  };

  const te_many = (entityKey: string): string => {
    return store.getters['i18n/getEntityTranslation'](entityKey, 'many');
  };

  const getAllEntities = () => {
    return store.getters['i18n/getAllEntities'];
  };

  return {
    tg,
    tp,
    te,
    te_one,
    te_many,
    getAllEntities,
    setPageTranslations,
    setGroupTranslations,
    clearTranslations,
  };
}
